import gql from 'graphql-tag';

export const MY_RIDE_REQUESTS_QUERY = gql`
  query getMyRideRequests {
    getMyRideRequests {
      id
      passenger {
        id
        firstName
        lastName
        gender
        userImg
        userVehicles {
          make {
            name
          }
          model
          spec {
            engineSize
            fuelConsumption
          }
        }
      }
      ride {
        id
        status
        driver {
          id
          firstName
          lastName
          gender
          userImg
          userVehicles {
            make {
              name
            }
            model
            spec {
              engineSize
              fuelConsumption
            }
          }
        }
        seats
        startDate
        pricePerSeat
        startPoint {
          name
          location {
            lat
            lng
          }
          eta
        }
        endPoint {
          name
          location {
            lat
            lng
          }
          eta
        }
        waypoints {
          id
          name
          location {
            lat
            lng
          }
        }
        waypointsEta {
          waypointId
          eta
        }
        createdAt
      }
      requestedSeatsCount
      status
      message
      createdAt
    }
  }
`;
